import { connectedRouterRedirect } from "redux-auth-wrapper/history4/redirect";
import { routerActions } from "react-router-redux";
import { checkAuthDataValidity } from "./authData";
import { hasToRedirectToPatientPlaylist } from "./AuthTools";

export default connectedRouterRedirect({
  redirectPath: hasToRedirectToPatientPlaylist()
    ? "/patient-playlists"
    : "/login",
  authenticatedSelector: (state) => {
    // console.log(state.login)
    const { authData } = state.login;
    // console.log(subdomain);
    return typeof authData !== "undefined" && checkAuthDataValidity(authData);
  },
  wrapperDisplayName: "UserAuthenticated",
  redirectAction: routerActions.replace,
});



// WEBPACK FOOTER //
// ./src/pages/utils/auth/UserAuthenticated.js